module.exports = __webpack_public_path__ + "static/img/guide@2x.5a3c9233.png";